import { Popper } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  tableHeader: {
    fontSize: '0.8em',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#10366E',
    textTransform: 'uppercase',
    textAlign: 'center !important;',
  },
  tableRow: {
    fontSize: '0.8em',
    textAlign: 'center !important;',
  },
  tableRowLarger: {
    fontSize: '0.9em',
    textAlign: 'center !important;',
  },
  tableRowReport: {
    fontSize: '0.6em',
    textAlign: 'center !important;',
  },
  tableHeaderReport: {
    fontSize: '0.6em',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#10366E',
    textTransform: 'uppercase',
    textAlign: 'center !important;',
    lineHeight: '15px',
  }
});

export const autocompletePopperStyles = (theme) => ({
  popper: {
    maxWidth: 'fit-content',
  },
});
export const PopperFullWidth = function (props) {
  return (
    <Popper
      {...props}
      style={{ maxWidth: "fit-content", zIndex: 1500 }}
      placement="bottom-start"
    />
  );
};

export const getInputProps = () => ({
  style: { fontSize: '0.8em', padding: 10 },
});
export const getAutocompleteInputProps = (inheritedInputProps) => ({
  ...inheritedInputProps,
  style: { fontSize: '.9em', padding: 10 },
});

export const getDatePickerInputProps = (inheritedInputProps) => ({
  ...inheritedInputProps,
  style: { fontSize: '.9em', padding: 5 },
});
export const getInputLabelProps = () => ({ style: { fontSize: '1em' } });
